import Cookies from 'universal-cookie';
import { showError } from '../redux/snackbar';
import moment from 'moment'
import "moment/locale/tr";
moment.locale('tr')
// Cookies
const cookies = new Cookies();

// Timeout
const timeout = (ms, data) => new Promise(resolve => setTimeout(() => resolve(data), ms))

// Format plate
function plateSplitter(plate) {
    if (!plate) return ''
    const spilittedPlate = plate.match(new RegExp('([0-9]+)|([a-zA-Z]+)', 'g'));
    if (!spilittedPlate) return ''
    return spilittedPlate.join(' ')
}

function quickSortObjectsByDistance(arr) {
    if (arr.length <= 1) {
        return arr;
    }

    const pivotIndex = Math.floor(Math.random() * arr.length); // Choose a random pivot index
    const pivotDistance = arr[pivotIndex].distance;
    const left = [];
    const right = [];

    for (let i = 0; i < arr.length; i++) {
        if (i === pivotIndex) {
            continue; // Skip the pivot element
        }
        const currentDistance = arr[i].distance;
        if (currentDistance < pivotDistance) {
            left.push(arr[i]);
        } else {
            right.push(arr[i]);
        }
    }

    return [
        ...quickSortObjectsByDistance(left),
        arr[pivotIndex],
        ...quickSortObjectsByDistance(right)
    ];
}

// Error handler on api calls
function handleError(e, dispatch, t, callback) {
    if (e instanceof Error) {
        console.error(e)
        dispatch(showError(t('UNKNOWN_ERROR')))
    }
    else {
        callback()
    }
}

function capitilize(text) {
    return text.charAt(0).toLocaleUpperCase('tr') + text.slice(1)
}
function numberWithSeperators(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return parts.join(",");
}

function formatAddress(text) {
    return text.toLocaleLowerCase('tr').split(' ').map(w => capitilize(w)).join(' ')
}
function getDistance(lat1, lon1, lat2, lon2) {
    var radlat1 = Math.PI * lat1 / 180;
    var radlat2 = Math.PI * lat2 / 180;
    var theta = lon1 - lon2;
    var radtheta = Math.PI * theta / 180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;
    dist = dist * 1.609344;

    return dist;
};

function getDistanceAndDuration(origin, destination) {
    const R = 6371; // Dünya yarıçapı (km)
    const AVERAGE_SPEED_KMH = 80; // Sabit hız

    const dLat = (destination.lat - origin.lat) * Math.PI / 180;
    const dLon = (destination.lng - origin.lng) * Math.PI / 180;

    const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(origin.lat * Math.PI / 180) *
        Math.cos(destination.lat * Math.PI / 180) *
        Math.sin(dLon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;

    const durationHours = distance / AVERAGE_SPEED_KMH;
    const hours = Math.floor(durationHours);
    const minutes = Math.round((durationHours - hours) * 60);

    return {
        distance: distance * 1000,
        duration: `${hours} saat ${minutes} dakika (yaklaşık)`
    };
}


function getLocation(successCallback, errorCallback) {

    const LOCATION_PERMISSION = {
        UNDETERMINED: 'Undetermined',
        UNSUPPORTED: 'Unsopperted',
        GRANTED: 'Granted',
        DENIED: 'Denied'
    }

    // Gelocation is supported
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            // Success
            position => {
                successCallback(position, LOCATION_PERMISSION.GRANTED);
            },
            // Fail
            error => {
                errorCallback(LOCATION_PERMISSION.DENIED);
            },
            // Options
            { enableHighAccuracy: true }
        );
    }
    // Gelocation is not supported
    else {
        errorCallback(LOCATION_PERMISSION.UNSUPPORTED);
    }
}

const createAppointmentTimeSlots = () => {
    let date = moment().format('YYYY-MM-DD');
    let timeSlots = []
    do {
        date = moment(date, 'YYYY-MM-DD').add(1, 'days')
        let weekDay = date.isoWeekday()

        // exclude sundays
        if (weekDay == 7) continue

        const timeSlotDay = {
            date: date.format('YYYY-MM-DD'),
            day: date.format('DD'),
            month: date.format('MM'),
            shortDayName: date.format('ddd'),
            slots: []
        };
        for (let hour = 8; hour < 17; hour++) {

            // exclude lunch time
            if (hour == 12) continue
            //exclude saturday hours after 13:45
            if (weekDay == 6 && hour > 13) continue
            timeSlotDay.slots.push(moment({ hour }).format('HH:mm'));
            for (let minute = 15; minute < 60; minute = minute + 15) {
                timeSlotDay.slots.push(
                    moment({
                        hour,
                        minute: minute
                    }).format('HH:mm')
                );
            }
        }

        timeSlots.push(timeSlotDay)
    } while (timeSlots.length !== 11);


    return timeSlots
}
function formatPhone(value, pattern) {
    let i = 0;
    const v = value.toString();
    return pattern.replace(/#/g, _ => v[i++] ?? '');
}

export {
    timeout,
    cookies,
    plateSplitter,
    handleError,
    capitilize,
    formatAddress,
    getDistance,
    getLocation,
    numberWithSeperators,
    createAppointmentTimeSlots,
    formatPhone,
    quickSortObjectsByDistance,
    getDistanceAndDuration
}